module.exports = __webpack_public_path__ + "img/allhouse_Illustrations_Search.9d8ddc4d.png";